document.addEventListener('DOMContentLoaded', function() {
  toggleproductdetalsInit()
});

function toggleproductdetalsInit() {
  var collapsibleOptions = document.querySelectorAll('.collapsible-product-options');

  collapsibleOptions.forEach(function(optionContainer) {
    var productOptions = optionContainer.querySelectorAll('.product-option');

    // Show the first 2 options and hide the rest
    for (var i = 2; i < productOptions.length; i++) {
      productOptions[i].style.display = 'none';
    }

    if (productOptions.length > 2) {
      // Show the toggle button if there are more than 2 options
      var toggleButton = optionContainer.querySelector('.toggle-options');
      toggleButton.style.display = 'flex';

      // Remove previous event listener, if any so we do not get duppicated event listeners
      toggleButton.removeEventListener('click', toggleProductDetailsHandler);

      // Add the event listener
      toggleButton.addEventListener('click', toggleProductDetailsHandler);
    }
  });
}

function toggleProductDetailsHandler() {
  var toggleButton = this;
  var productOptions = toggleButton.parentElement.querySelectorAll('.product-option');

  // Toggle visibility of hidden options
  for (var i = 2; i < productOptions.length; i++) {
    var toggleButtonText = toggleButton.querySelector('.toggle-option_text');

    if (productOptions[i].style.display === 'none') {
      productOptions[i].style.display = 'flex';
      toggleButtonText.textContent = 'Toon minder';
      toggleButtonText.classList.add('details-visible');
    } else {
      productOptions[i].style.display = 'none';
      toggleButtonText.textContent = 'Toon meer';
      toggleButtonText.classList.remove('details-visible');
    }
  }
}

//Check if the div is reloaded. If it is fure the function so the details are not being show.
$(document).on('DOMSubtreeModified', '#mainCartTotals', function(event) {
  if ($(event.target).is('.price-final, .price-final *')) {
    toggleproductdetalsInit()
  }
});
